<template>
  <!-- Header section starts here -->
  <header id="landing-section">
    <div
      id="carouselExampleAutoplaying"
      class="carousel slide"
      data-bs-ride="carousel"
    >
      <div class="carousel-inner">
        <div class="carousel-item active" data-bs-interval="3000">
          <img
            :src="landingBanner"
            class="d-block w-100 carousel-image"
            alt="..."
          />

          <div class="inner-caption">
            <h5 class="landing_heading text-white text-center">
              Get access to a wide range of healthcare services in one click
            </h5>
            <p class="landing_paragraph text-white text-center">
              Choose your health benefits and care facilities today.
            </p>
            <button class="btn btn-block btn-md d-block mx-auto join-ark-btn">
              Join the Ark
            </button>
          </div>
        </div>

        <div class="carousel-item" data-bs-interval="3000">
          <img
            :src="landingBanner"
            class="d-block w-100 carousel-image"
            alt="..."
          />

          <div class="inner-caption">
            <h5 class="landing_heading text-white text-center">
              Choose your health benefits and care facilities today
            </h5>
            <p class="landing_paragraph text-white text-center">
              Get the same day immediate access to care in over 4,000 healthcare
              facilities nationwide
            </p>
            <button class="btn btn-block btn-md d-block mx-auto join-ark-btn">
              Join the Ark
            </button>
          </div>
        </div>

        <div class="carousel-item active" data-bs-interval="3000">
          <img
            :src="landingBanner"
            class="d-block w-100 carousel-image"
            alt="..."
          />

          <div class="inner-caption">
            <h5 class="landing_heading text-white text-center">
              Get the same day immediate access to care in over 4,000 healthcare
              facilities nationwide
            </h5>
            <p class="landing_paragraph text-white text-center">
              We take the burden off you in scanning through hundreds of care
              plans and offer you the most optimized plan for your needs
            </p>
            <button class="btn btn-block btn-md d-block mx-auto join-ark-btn">
              Join the Ark
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Why should Join Ark section starts here -->
  <section id="why-join-ark">
    <div class="container">
      <div class="row content-top">
        <div class="col-12 col-md-5 mb-3">
          <p class="join-ark-text">Why you should join the Ark?</p>
        </div>
        <div class="col-12 col-md-7 mb-3">
          <p class="text">
            We take the burden off you in scanning through hundreds of care
            plans and offer you the most optimized plan for your needs
          </p>
        </div>
      </div>

      <div class="slider-down row mb-3">
        <div class="col-12 col-md-3 mb-3 p-3">
          <div class="slider-wrapper">
            <img
              :src="bestPlanImg"
              alt="Best Premium Plan - Health Ark"
              class="d-block mx-auto mb-2"
            />
            <p class="text-center">Best Premium Plan</p>
            <span class="d-block text-center"
              >Compare all available plans across over 30 HMOs and choose a plan
              custom to you</span
            >
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3 p-3">
          <div class="slider-wrapper">
            <img
              :src="simplifiedPlanImg"
              alt="Simplified Plan -  Health Ark"
              class="d-block mx-auto mb-2"
            />
            <p class="text-center">Simplified plans</p>
            <span class="d-block text-center"
              >Simplified plans, no hidden T&C, no hidden costs</span
            >
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3 p-3">
          <div class="slider-wrapper">
            <img
              :src="scalableImg"
              alt="Scalable - Health Ark"
              class="d-block mx-auto mb-2"
            />
            <p class="text-center">Scalable</p>
            <span class="d-block text-center"
              >We can broker coverage for organizations with as small as 1 staff
              to as large as 5000 staff</span
            >
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3 p-3">
          <div class="slider-wrapper">
            <img
              :src="economicalImg"
              alt="Economical - Health Ark"
              class="d-block mx-auto mb-2"
            />
            <p class="text-center">Economical</p>
            <span class="d-block text-center"
              >Cost-effective for SMEs and Large scale organizations (save up to
              30% on sign-up cost)</span
            >
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3 p-3">
          <div class="slider-wrapper">
            <img
              :src="bestDealImg"
              alt="Best Deal - Health Ark"
              class="d-block mx-auto mb-2"
            />
            <p class="text-center">Best Deals</p>
            <span class="d-block text-center"
              >Get the best deals for HMO sign ups</span
            >
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3 p-3">
          <div class="slider-wrapper">
            <img
              :src="easeImg"
              alt="Ease Of Access - Health Ark"
              class="d-block mx-auto mb-2"
            />
            <p class="text-center">Ease of Access</p>
            <span class="d-block text-center"
              >Choose and switch across over 30 HMOs at one click</span
            >
          </div>
        </div>
        <div class="col-12 col-md-3 mb-3 p-3">
          <div class="slider-wrapper">
            <img
              :src="instantAccessImg"
              alt="Instant Access - Health Ark"
              class="d-block mx-auto mb-2"
            />
            <p class="text-center">Instant Access</p>
            <span class="d-block text-center"
              >Cost-effective for SMEs and Large scale organizations (save up to
              30% on sign-up cost)</span
            >
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SLider section -->
  <!-- <section id="slider-section">
    <div class="container">
      <div
        id="carouselExampleAutoplaying"
        class="carousel slide d-block d-sm-none mt-3 mb-3"
        data-bs-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="w-100 slider-block p-5">
              <div class="col-12">
                <div class="slider-wrapper">
                  <img
                    :src="bestPlanImg"
                    alt="Best Premium Plan - Health Ark"
                    class="d-block mx-auto mb-2"
                  />
                  <p class="text-center">Best Premium Plan</p>
                  <span class="d-block text-center"
                    >Compare all available plans across over 30 HMOs and choose
                    a plan custom to you</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="w-100 slider-block p-5">
              <div class="col-12">
                <div class="slider-wrapper">
                  <img
                    :src="simplifiedPlanImg"
                    alt="Simplified Plan -  Health Ark"
                    class="d-block mx-auto mb-2"
                  />
                  <p class="text-center">Simplified plans</p>
                  <span class="d-block text-center"
                    >Simplified plans, no hidden T&C, no hidden costs</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="w-100 slider-block p-5">
              <div class="col-12">
                <div class="slider-wrapper">
                  <img
                    :src="scalableImg"
                    alt="Scalable - Health Ark"
                    class="d-block mx-auto mb-2"
                  />
                  <p class="text-center">Scalable</p>
                  <span class="d-block text-center"
                    >We can broker coverage for organizations with as small as 1
                    staff to as large as 5000 staff</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="w-100 slider-block p-5">
              <div class="col-12">
                <div class="slider-wrapper">
                  <img
                    :src="economicalImg"
                    alt="Economical - Health Ark"
                    class="d-block mx-auto mb-2"
                  />
                  <p class="text-center">Economical</p>
                  <span class="d-block text-center"
                    >Cost-effective for SMEs and Large scale organizations (save
                    up to 30% on sign-up cost)</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="w-100 slider-block p-5">
              <div class="col-12">
                <div class="slider-wrapper">
                  <img
                    :src="bestDealImg"
                    alt="Best Deal - Health Ark"
                    class="d-block mx-auto mb-2"
                  />
                  <p class="text-center">Best Deals</p>
                  <span class="d-block text-center"
                    >Get the best deals for HMO sign ups</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="w-100 slider-block p-5">
              <div class="col-12">
                <div class="slider-wrapper">
                  <img
                    :src="easeImg"
                    alt="Ease Of Access - Health Ark"
                    class="d-block mx-auto mb-2"
                  />
                  <p class="text-center">Ease of Access</p>
                  <span class="d-block text-center"
                    >Choose and switch across over 30 HMOs at one click</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="w-100 slider-block p-5">
              <div class="col-12">
                <div class="slider-wrapper">
                  <img
                    :src="instantAccessImg"
                    alt="Instant Access - Health Ark"
                    class="d-block mx-auto mb-2"
                  />
                  <p class="text-center">Instant Access</p>
                  <span class="d-block text-center"
                    >Cost-effective for SMEs and Large scale organizations (save
                    up to 30% on sign-up cost)</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </section> -->

  <!-- Health insurance coverage section -->
  <section id="health-insurance-section">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-7 mb-3 d-flex align-items-center">
          <div class="content-wrapper">
            <p class="health-insurance-text">
              Finally we have all your health needs in one place
            </p>
            <ul class="insurance-list">
              <li class="health-text-container">
                <router-link to="" class="health-text text-active"
                  >Health Insurance Coverage</router-link
                >
              </li>
              <li class="tele-text-container">
                <router-link to="" class="tele-text">Telemedicine</router-link>
              </li>
              <li class="medi-text-container">
                <router-link to="" class="medi-text"
                  >Medical Referrals</router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-5 mb-3 p-4">
          <div class="insurance-box p-4">
            <p>Our Health Insurance Coverage</p>
            <div class="image-wrapper">
              <img
                :src="healthInsuranceImg"
                alt=""
                style="border-radius: 10px 0 0 10px"
              />
              <!-- <img :src="healthInsuranceImg" alt="" />
              <img :src="healthInsuranceImg" alt="" /> -->
              <img :src="healthInsuranceImg" alt="" />
              <img
                :src="healthInsuranceImg"
                alt=""
                style="border-radius: 0 10px 10px 0"
              />
            </div>
            <span
              >We are an independent health insurance brokerage based in Lagos
              with a primary objective of easing the burden of access to an
              otherwise strained Healthcare System</span
            >

            <button class="btn btn-block btn-sm">Read more</button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Download Ark store section starts here -->
  <DownloadArkStore />

  <section id="client-section">
    <div class="container">
      <p class="client-head"><span>Clients</span> we have served</p>
      <div class="row">
        <div class="col-12 col-md-12 p-3 col-lg-3 mb-3 beach-tv">
          <img :src="beachTvImg" alt="" />
        </div>
        <div class="col-12 col-md-12 p-3 col-lg-3 mb-3 property">
          <img :src="revelationProperty" alt="" />
        </div>
        <div class="col-12 col-md-12 p-3 col-lg-3 mb-3 land-shop">
          <img :src="landshop" alt="" />
        </div>
        <div class="col-12 col-md-12 p-3 col-lg-3 mb-3 farm-park">
          <img :src="farmParkImg" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import DownloadArkStore from "@/components/DownloadArkStore.vue";
import { onMounted, getCurrentInstance } from "vue";


export default {
  name: "Home",
  components: {
    Navbar,
    DownloadArkStore,
    Footer,
  },
  setup() {
    // images
    const landingBanner = "/img/header_banner.png";
    const bestPlanImg = "/img/wja7.png";
    const simplifiedPlanImg = "/img/wja2.png";
    const scalableImg = "/img/wja3.png";
    const economicalImg = "/img/wja4.png";
    const bestDealImg = "/img/wja5.png";
    const easeImg = "/img/wja6.png";
    const instantAccessImg = "/img/wja1.png";
    const healthInsuranceImg = "/img/Post-Dark-theme.png";
    const beachTvImg = "/img/Beachtv_media_logo.png";
    const farmParkImg = "/img/Farm_park_logo.png";
    const landshop = "/img/Landshop_Logo.png";
    const revelationProperty = "/img/Revelation_Properties_Logo.png";
    
    
    onMounted(() => {
      const internalInstance = getCurrentInstance();
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    internalInstance.appContext.config.globalProperties.$Progress.start();
      window.scrollTo(0, 0)
      internalInstance.appContext.config.globalProperties.$Progress.finish();
    })


    return {
      landingBanner,
      bestPlanImg,
      simplifiedPlanImg,
      scalableImg,
      economicalImg,
      bestDealImg,
      easeImg,
      instantAccessImg,
      healthInsuranceImg,
      beachTvImg,
      farmParkImg,
      landshop,
      revelationProperty,
    };
  },
};
</script>

<style scoped>
* {
  text-decoration: none !important;
  list-style-type: none;
}
#landing-section {
  background-color: var(--Ghost-White);
  min-height: 100vh;
  position: relative;
  padding-top: 70px;
}
.carousel-image {
  object-fit: cover;
  min-height: 100vh;
}
.inner-caption {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .landing_heading {
    font-size: 40px !important;
  }
  .inner-caption {
    width: 80%;
  }
}

@media screen and (max-width: 768px) {
  .landing_heading {
    font-size: 35px !important;
  }
  .inner-caption {
    width: 90%;
  }
  .join-ark-btn {
    margin-top: 64px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1440px) {
  .landing_heading {
    font-size: 50px !important;
  }
  .inner-caption {
    width: 70%;
  }
}
a {
  color: #fff;
}
.landing_heading {
  font-size: var(--fs-60);
  font-weight: var(--fw-700);
  font-family: var(--ff-poppins);
}
.join-ark-btn:focus,
.join-ark-btn:hover {
  background-color: var(--Cerulean);
  color: #fff;
}

/* STYLING FOR WHY JOIN ARK STARTS HERE */
.content-top {
  margin: 102px 0;
}
.join-ark-text {
  font-family: var(--ff-poppins);
  font-size: var(--fs-48);
  font-weight: var(--fw-700);
}

@media screen and (max-width: 768px) {
  .join-ark-text {
    text-align: center;
  }
}

.slider-wrapper > p,
.slider-wrapper > span {
  font-family: var(--ff-OpenSans);
}
.slider-wrapper > p {
  font-weight: var(--fw-700);
  font-size: var(--fs-20);
}
.slider-wrapper > span {
  font-weight: var(--fw-400);
}
.slider-block {
  background-color: var(--snow-white);
  border-radius: 8px !important;
}

/* STYLING FOR HEALTH INSURANCE COVERGAE STARTS HERE */
.health-insurance-text {
  font-size: var(--fs-32);
  font-weight: var(--fw-700);
  font-family: var(--ff-poppins);
}

@media screen and (max-width: 768px) {
  .health-insurance-text {
    text-align: center;
  }
}
.insurance-list {
  margin-top: 40px;
}
.text-active {
  color: var(--Cerulean);
}
.tele-text,
.medi-text {
  color: var(--gray);
}
.health-text,
.tele-text,
.medi-text {
  font-family: var(--ff-OpenSans);
  font-weight: var(--fw-700);
  font-size: var(--fs-20);
  text-transform: uppercase;
}
.health-text-container,
.tele-text-container,
.medi-text-container {
  padding: 16px 32px;
  box-shadow: 0px 0px 8px 0px #4545451a;
  margin: 8px 0;
}
.image-wrapper {
  display: flex;
  margin-bottom: 16px;
}
.insurance-box {
  background-color: var(--grayish-white);
  border-radius: 8px;
  box-shadow: 0px 0px 2px rgba(69, 69, 69, 0.25);
}
.insurance-box > p {
  font-family: var(--ff-poppins);
  font-weight: var(--fw-700);
  font-size: var(--fs-32);
  line-height: 42px;
  margin-bottom: 17px;
}
.insurance-box > span {
  font-family: var(--ff-OpenSans);
  font-weight: var(--fw-400);
  margin-bottom: 32px;
  display: block;
}

@media screen and (max-width: 768px) {
  .insurance-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .tele-text,
  .health-text,
  .medi-text {
    text-transform: none;
    font-size: 16px;
  }
  .image-wrapper > img {
    width: 33.33%;
  }
  .insurance-box > p {
    font-size: 22px;
    text-align: center;
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .health-insurance-text {
    text-align: center;
  }
}

/* STYLING FOR CLIENT SECTION STARTS HERE */
#client-section {
  margin: 100px 0;
}
.client-head {
  font-family: var(--ff-roboto);
  font-weight: var(--fw-700);
  font-size: var(--fs-48);
  line-height: 64px;
  margin-bottom: 50px;
}
.client-head > span {
  font-weight: inherit !important;
  border-bottom: 4px solid var(--Cerulean);
  font-family: var(--ff-roboto);
}
.farm-park,
.land-shop {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 992px) {
  .beach-tv,
  .property,
  .land-shop,
  .farm-park {
    display: flex;
    justify-content: flex-start;
    /* border: 2px solid black; */
  }
}
</style>
